import {Text, TextField} from '@/components/atoms'
import {PromotionCondition, type DiscountType} from '@/types/promotion'
import {FC} from 'react'
import {useRewardDiscount} from './useRewardDiscount'

type DiscountInputProps = {
  promotionCondition: PromotionCondition
  textBeforeInput?: string
  textAfterInput?: string
  showDynamicPlaceholder?: boolean
  discountType?: DiscountType
  index?: number
  rewardIndex?: number
}

export const RewardDiscount: FC<DiscountInputProps> = ({
  promotionCondition,
  textAfterInput = '% off.',
  showDynamicPlaceholder = false,
  discountType,
  rewardIndex = 0,
}) => {
  const {
    currencyCode,
    isCashDiscount,
    isPercentageDiscount,
    placeholderText,
    decimalLimit,
    discountValue,
    maxDiscountValue,
    errorText,
    maxDiscountError,
    hasErrorWithoutMessage,
    handleDiscountChange,
    handleMaxDiscountChange,
  } = useRewardDiscount({promotionCondition, showDynamicPlaceholder, discountType, rewardIndex})

  const className = hasErrorWithoutMessage ? 'disable-error-icon' : ''

  return (
    <>
      {isCashDiscount && <Text>{currencyCode}</Text>}
      <TextField
        updateValue={handleDiscountChange}
        value={discountValue}
        error={errorText}
        maxDecimals={decimalLimit}
        uiSchema={{
          helperText: '',
          placeholder: placeholderText,
          className: className,
        }}
        // @ts-expect-error TextField style typing does not include width
        style={{width: '150px'}}
        type="number"
      />
      {!isCashDiscount && <Text>{textAfterInput}</Text>}
      {isPercentageDiscount && (
        <>
          <Text>Max Discount Value $ </Text>
          <TextField
            updateValue={handleMaxDiscountChange}
            value={maxDiscountValue}
            error={maxDiscountError}
            uiSchema={{
              helperText: '',
              className: className,
            }}
            // @ts-expect-error TextField style typing does not include width
            style={{width: '150px'}}
            type="number"
            min={0}
          />
        </>
      )}
    </>
  )
}
